import { LessonsMultiple } from '@berlitz/icons'
import DashboardCard from '@components/DashboardCard'
import { ProgramStudentInfo } from '@interfaces/Student'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { StyledCol } from './style'

const CardBulkBook: React.FunctionComponent<ProgramStudentInfo> = ({ ProgramId, BulkScheduling }) => {
  const intl = useIntl()

  if (BulkScheduling) {
    return (
      <StyledCol xs={12} sm={6} md={6} lg={3}>
        <DashboardCard
          link={`/scheduling/all-lessons?id=${ProgramId}`}
          loading={false}
          icon={<LessonsMultiple />}
          title={intl.formatMessage({ id: 'Book all lessons' })}
        >
          <FormattedMessage id="Stats show students with all classes booked have a higher chance of completing goals" />
        </DashboardCard>
      </StyledCol>
    )
  }

  return null
}
export default CardBulkBook
